import { useState, type ReactNode } from 'react';
import { currentSupabaseEnv } from '@/lib/supabase';
import { LiveDemoContext } from './LiveDemoContext';

export function LiveDemoProvider({ children }: { children: ReactNode }) {
  const [isLiveDemoEnabled, setIsLiveDemoEnabled] = useState(false);

  // Live-demo mode drives SIMULATED KPI fluctuations (useLiveDemo) — the
  // single choke point lives here so no entry point (desktop switch, mobile
  // header button, future controls) can enable it outside the demo env.
  const isDemoEnv = currentSupabaseEnv === 'demo';

  const guardedSet = (enabled: boolean) => {
    setIsLiveDemoEnabled(isDemoEnv && enabled);
  };

  const toggleLiveDemo = () => {
    setIsLiveDemoEnabled((prev) => isDemoEnv && !prev);
  };

  return (
    <LiveDemoContext.Provider
      value={{
        isLiveDemoEnabled,
        setLiveDemoEnabled: guardedSet,
        toggleLiveDemo,
      }}
    >
      {children}
    </LiveDemoContext.Provider>
  );
}
